import { __makeTemplateObject } from '../../../../../../../../../node_modules/tslib/tslib.es6.js';
import { styled, css } from '@mui/system';
import { Typography } from '@mui/material';

var FiltersCount = styled(Typography)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: ", ";\n  width: 16px;\n  height: 16px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: ", ";\n  font-weight: 600;\n  font-size: 12px;\n  border-radius: 50%;\n  ", ";\n  letter-spacing: normal;\n"], ["\n  background: ", ";\n  width: 16px;\n  height: 16px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: ", ";\n  font-weight: 600;\n  font-size: 12px;\n  border-radius: 50%;\n  ", ";\n  letter-spacing: normal;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.neutral500;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.links;
}, function (_a) {
    var _b, _c;
    var theme = _a.theme;
    return ((_c = (_b = theme.typography) === null || _b === void 0 ? void 0 : _b.fontFamily) === null || _c === void 0 ? void 0 : _c.includes("Avenir Next")) && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      /* Avoid Avenir Next due to bottom margin centering issue */\n      font-family: Roboto, Helvetica, Arial;\n    "], ["\n      /* Avoid Avenir Next due to bottom margin centering issue */\n      font-family: Roboto, Helvetica, Arial;\n    "])));
});
var templateObject_1, templateObject_2;

export { FiltersCount };
